import Feature from "src/js/stores/user/Feature";
import { ConstraintsCategory } from "../../Constraints/types";
import { ConstraintsLayerType } from "../layer_types/ConstraintsLayerType";
import { Layer, LayerGroup } from "../types";

export const OPPORTUNITY_ZONES: Layer = {
  id: ConstraintsCategory.US_OPPORTUNITY_ZONES,
  layerType: ConstraintsLayerType,
  hideByDefault: true,
  title: "Opportunity zones",
  requiredFeatureAccess: [Feature.zoningLayer],
  toggleable: true,
  group: LayerGroup.ZONING,
  icon: "lt-road-map-line",
  description: "Revitalize low income areas",
  layerConfig: {
    rootCategory: ConstraintsCategory.US_OPPORTUNITY_ZONES,
    categorySchema: [{ key: "us_opportunity_zones" }],
  },
  zoomConfig: {
    minVisualisationZoom: 10,
  },
};
